import { useState } from 'react';
import { Modal } from '../../Modal';
import { Button, Input, Typography } from '../ui';
import { devToolsUnlocked } from '../../../lib/dev-tools';
import { readEmailCampaignPreviewCard } from '../../../lib/email-review';
import { useActiveConversation } from '../../chat/ActiveConversationContext';
import { EmailCampaignPreviewCard } from '../chat-surface/MessageRow/EmailCampaignPreviewCard';

export function DevEmailCampaignPreviewPanel(props: { open: boolean; onClose: () => void }) {
  if (!devToolsUnlocked()) return null;
  return <EmailCampaignPreviewPanel {...props} />;
}

function EmailCampaignPreviewPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { activeConversationId } = useActiveConversation();
  const [metaSiteId, setMetaSiteId] = useState('');
  const [campaignId, setCampaignId] = useState('');
  const [subject, setSubject] = useState('');
  const card = readEmailCampaignPreviewCard({ emailCampaignPreviewCard: { metaSiteId, campaignId, subject, decisionId: 'dev', taskId: 'dev' } });
  return (
    <Modal open={open} onClose={onClose} width={560} title="Email campaign preview card" footer={<Button onClick={onClose}>Done</Button>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Typography variant="p3" color="secondary">
          The card a held campaign send puts on its reply, for one of your own sites&apos; draft campaigns. Its review sends the finished comments
          to the open chat.
        </Typography>
        <Input label="Site (metaSiteId)" value={metaSiteId} onChange={(e) => setMetaSiteId(e.target.value.trim())} />
        <Input label="Campaign id" value={campaignId} onChange={(e) => setCampaignId(e.target.value.trim())} />
        <Input label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
        {card ? (
          <EmailCampaignPreviewCard card={card} conversationId={activeConversationId ?? undefined} />
        ) : (
          <Typography variant="p3" color="secondary">
            Both ids are GUIDs.
          </Typography>
        )}
      </div>
    </Modal>
  );
}
